module.exports = __webpack_public_path__ + "img/branded-coin.46216ab6.png";